module.exports = __webpack_public_path__ + "Roboto-Light.46e48ce0628835f68a73.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/font/roboto/Roboto-Light.ttf
// module id = ../../../../../font/roboto/Roboto-Light.ttf
// module chunks = styles